import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { Grid, Card, Snackbar, TextField } from "@material-ui/core";
import clsx from "clsx";
import { Alert } from "@material-ui/lab";
import Group10 from "assets/images/causes/Group10.png";
import Group256 from "assets/images/causes/Group256.png";
import P1 from "assets/images/causes/p1.png";
import P2 from "assets/images/causes/p2.png";
import P3 from "assets/images/causes/p3.png";
import P4 from "assets/images/causes/p4.png";
import P5 from "assets/images/causes/p5.png";
import ZwagilFoundationImage from "assets/images/Group254.png";
import causesData from "testdata/causesData";
import { useHistory } from "react-router-dom";
import DonateCart from "./DonateCart";
import { callGetApiWithAuth } from "utils/api";

export default function DonatePage(props) {
  const classes = useStyles();
  const myUser = useSelector((state) => state.auth.user);
  const history = useHistory();

  const id = props.match.params.id;

  const [formData, setFormData] = useState({
    product_id: 46,
    quantity: 1,
    cycle: 1,
    amount: 25,
    unitAmount: 25,
  });
  const [allCauses, setAllCauses] = useState([]);
  const [showAllCauses, setShowAllCauses] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCart, setShowCart] = useState(false);
  const [teamList, setTeamList] = useState([])

  const submitDonation = () => {
    if (formData.amount == "" || formData.amount < 0) {
      setErrorMessage("Please add amount!");
      setFormData({ ...formData, amount: 25 });
      return;
    } else {
      if (showAllCauses) {
        setAllCauses([
          ...causesData.map((el) => {
            return {
              ...formData,
              product_id: el.id,
              image: el.image,
              title: el.title,
            };
          }),
        ]);
        setShowCart(true);
        return;
      } else {
        setShowCart(true);
        return;
      }
    }
  };

  const CauseData =
    causesData.length > 0
      ? causesData.find((x) => x.id == formData?.product_id)
      : {};

  const onSuccessGetTeamList =({ data }) => {
    setTeamList(data);
  }

  const onFaileGetTeamList = (err) => {

  }

  useEffect(() => {
    if (!myUser?.shipping_detail || !myUser?.billing_detail) {
      setErrorMessage("Please fill shipping info and billing info first");
      setTimeout(() => {
        history.push("/settings");
      }, 1500);
    } else {
      callGetApiWithAuth("donate/team_list", onSuccessGetTeamList, onFaileGetTeamList)
    }
  }, []);

  return (
    <div className={classes.container}>
      {!showCart ? (
        <>
          <div className={classes.donationBanner}>
            <div>Make a difference, make a donation.</div>
          </div>
          <div className={classes.donationInfo}>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={4}
                md={4}
                lg={3}
                xl={3}
                className={classes.causeImage}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "230px",
                  }}
                >
                  <img
                    alt="cause-data-img"
                    src={ZwagilFoundationImage}
                    width="257"
                    style={{
                      width: "auto",
                      height: "100%",
                      objectFit: "cover",
                      maxWidth: "100%",
                      maxHeight: "100%",
                    }}
                  />
                </div>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={4}
                className={classes.donationToC}
              >
                <div className={classes.donationTo}>
                  <div className={classes.partnerContent}>
                    YOU ARE DONATING TO:
                  </div>
                  <div className={classes.partnerHeading}>
                    Zwagil Foundation
                  </div>
                  <div className={classes.partnerContent}>
                    Every donation, no matter how small or big, can make a huge
                    difference. Remember, pick the cause you’re most passionate
                    about! The Internal Revenue Service (IRS) recognizes the
                    Zwagil Foundation as a private foundation, exempt from
                    federal income tax under Internal Revenue Code Section
                    501(c)(3). Contributions to the Zwagil Foundation are
                    eligible for tax deduction in the US.
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className={classes.donationPartnersContainer}>
            <Card className={classes.donationPartners}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={7}
                  xl={7}
                  className={classes.donationPartnersLogo}
                >
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className={classes.donationPartnersHeading}>
                        Our Partners
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={P1} width="150" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={P4} width="150" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={P5} width="200" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={P3} width="120" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={P2} width="170" />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                  <div className={classes.donateBox}>
                    <div className={classes.dontaeH4}>
                      Select Donation Amount
                    </div>
                    <ul className={classes.dolr} id="myDIV">
                      {[25, 100, 500, 1000].map(el => (
                        <li
                          className={clsx(
                            classes.btn,
                            formData.unitAmount == el ? classes.actDr : ""
                          )}
                          onClick={(e) =>
                            setFormData({ ...formData, 
                              amount: el*formData.quantity,
                              unitAmount: el, 
                            })
                          }
                        >
                          ${el}
                        </li>
                      ))}
                    </ul>
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {/* <TextField
                        className={classes.textInput}
                        label="Quantity"
                        value={formData.quantity}
                        onChange={(e) =>
                          setFormData({ ...formData, 
                            quantity: e.target.value,
                            amount: e.target.value*formData.unitAmount, 
                          })
                        }
                        style={{
                          margin: "10px auto 0px",
                          width: "85%",
                        }}
                      />
                      */}
                      <TextField
                        className={classes.textInput}
                        label="Custom Amount"
                        value={formData.amount}
                        onChange={(e) =>
                          setFormData({ ...formData, amount: e.target.value })
                        }
                        style={{
                          margin: "10px auto 0px",
                          width: "85%",
                        }}
                      />
                    </div>
                    {/* <div className={classes.foundationHead}>
                      <h6>FREQUENCY</h6>
                      <ul className={classes.week} id="mylist">
                        <li
                          className={clsx(
                            classes.btn,
                            formData.cycle == 1 ? classes.actWee : ""
                          )}
                          onClick={(e) =>
                            setFormData({ ...formData, cycle: 1 })
                          }
                        >
                          one-time
                        </li>
                        {(formData.product_id*1 === 1 || formData.product_id*1 === 2 || formData.product_id*1 === 3 || formData.product_id*1 === 4 || formData.product_id*1 === 5 || formData.product_id*1 === 39 || formData.product_id*1 === 41 || formData.product_id*1 === 42) &&
                          <>
                            <li
                              className={clsx(
                                classes.btn,
                                formData.cycle == 2 ? classes.actWee : ""
                              )}
                              onClick={(e) =>
                                setFormData({ ...formData, cycle: 2 })
                              }
                            >
                              weekly
                            </li>
                            <li
                              className={clsx(
                                classes.btn,
                                formData.cycle == 3 ? classes.actWee : ""
                              )}
                              onClick={(e) =>
                                setFormData({ ...formData, cycle: 3 })
                              }
                            >
                              monthly
                            </li>
                          </>
                        }
                      </ul>
                    </div> */}
                    <div
                      className={classes.foundationHead}
                      style={{
                        width: "100%",
                      }}
                    >
                      <h6>SELECT A CAUSE OR TEAM</h6>
                      <select
                        value={showAllCauses ? 5 : formData.product_id}
                        onChange={(e) => {
                          if (e.target.value == 5) {
                            setFormData({
                              ...formData,
                              product_id: e.target.value,
                            })
                            setShowAllCauses(true);
                          } else {
                            setFormData({
                              ...formData,
                              product_id: e.target.value,
                              cycle: e.target.value*1 < 6 ? formData.cycle : 1,
                            });
                            setShowAllCauses(false);
                          }
                        }}
                        style={{
                          margin: "10px auto 0px",
                          width: "85%",
                        }}
                      >
                        <option value={46}>Nashville - Children's Playground</option>
                        <option value={45}>Earth Day Children's Initiative</option>
                        <option value={2}>Feeding Children</option>
                        <option value={1}>Human Trafficking</option>
                        <option value={3}>Supporting Veterans</option>
                        <option value={4}>Protecting The Environment</option>
                        <option value={39}>Hurricane Ian Relief</option>
                        {/* <option value={41}>Holiday Toys Drive</option> */}
                        <option value={43}>Holidays with Children</option>
                        {/* <option value={44}>Game On - Super Bowl Squares Fundraiser</option> */}
                        {/* <option value={42}>Flags For Freedom</option> */}
                        {teamList && teamList.length > 0 && teamList.map((team) => (
                          <option value={team.id}>{team.title}</option>
                        ))}
                        <option value={5}>All Causes</option>
                      </select>
                      <button
                        onClick={submitDonation}
                        style={{
                          margin: "10px auto 0px",
                          width: "85%",
                        }}
                      >
                        DONATE NOW
                      </button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Card>
          </div>
        </>
      ) : (
        <DonateCart
          cartData={formData}
          allCauses={allCauses}
          showAllCauses={showAllCauses}
          teamList={teamList}
        />
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={errorMessage != ""}
        autoHideDuration={2000}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    minHeight: 400,
  },
  donationAmountCard: {
    padding: 30,
  },
  donationPartnersLogo: {
    padding: "50px 55px 30px",

    "@media (max-width: 1200px)": {
      padding: 20,
    },
  },
  donationPartnersHeading: {
    fontWeight: "bold",
    fontSize: 20,
    lineHeight: "40px",
    color: "#000000",
    fontFamily: "Poppins",
  },
  donationBanner: {
    height: 235,
    backgroundImage: `url(${Group10})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,

    "& div": {
      fontWeight: "bold",
      fontSize: 30,
      lineHeight: "45px",
      color: "#FFFFFF",
      textShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      textAlign: "center",
      paddingTop: "9%",
      fontFamily: "Poppins",
    },
  },
  donationTo: {
    padding: "45px 44px",

    "@media (max-width: 600px)": {
      padding: "0 44px 45px",
    },
    "@media (max-width: 959px)": {
      padding: "40px",
    },
    "@media (max-width: 1400px) and (min-width: 1280px)": {
      padding: "45px 0px",
    },
  },
  donationInfo: {
    minHeight: 265,
    backgroundImage: `url(${Group256})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    "& img": {
      padding: "51px 44px",

      "@media (max-width: 420px)": {
        width: "100%",
        padding: "10px 0px",
      },
      "@media (max-width: 600px)": {
        width: "100%",
        padding: "10px 0px",
      },
    },

    "@media (max-width: 959px)": {
      height: "auto",
    },

    "@media (max-width: 600px)": {
      height: "100%",
    },

    "@media (min-width: 1280px)": {
      height: "auto",
    },
  },
  textInput: {
    marginTop: 10,
  },
  partnerHeading: {
    fontWeight: "bold",
    fontSize: 20,
    lineHeight: "30px",
    color: "#FFFFFF",
    fontFamily: "Poppins",
  },
  partnerContent: {
    fontSize: 12,
    color: "#FFFFFF",
    opacity: 0.6,
    lineHeight: "18px",
    fontFamily: "Poppins",
  },
  donationPartners: {},
  donateBox: {
    width: "309px",
    minHeight: "505px",
    background: "#fff",
    padding: "20px 15px 10px 15px",
    margin: "-18% 0 0",
    position: "absolute",
    boxShadow: "0px 4px 10px rgb(0 0 0 / 10%)",

    "& ul": {
      display: "flex",
      flexFlow: "wrap",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: "0px",
      // margin: "0 -18px",
      // [theme.breakpoints.down("xs")]: {
      //   paddingLeft: '20px !important'
      // },
      // "@media (max-width: 1280px)": {
      //   margin: 0,
      // },
    },

    "& input": {
      width: "250px",
      margin: "5px 0 0",
    },

    "@media (min-width: 1700px)": {
      margin: "-238px 0 0",
    },
    "@media (max-width: 420px)": {
      width: "auto !important",
      height: "auto",
      padding: "20px 15px 20px 15px !important",
    },
    "@media (max-width: 600px)": {
      width: "auto !important",
      height: "auto",
      padding: "20px 15px 20px 15px !important",
      margin: "10px 0",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    "@media (max-width: 768px)": {
      width: "auto",
      height: "auto",
      marginBottom: 10,
      padding: 15,
    },
    "@media (max-width: 1480px)": {
      margin: "-25% 0 0",
    },
    "@media (max-width: 1550px)": {
      margin: "-22% 0 0",
    },
    "@media (max-width: 1400px)": {
      margin: 0,
      position: "inherit",
    },
  },
  dolr: {
    "& li": {
      fontFamily: "Poppins",
      textAlign: "center",
      width: "55px",
      height: "35px",
      border: "2px solid #3AC7FF",
      boxSizing: "border-box",
      borderRadius: "2px",
      float: "left",
      margin: "6px",
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "24px",
      color: "#3AC7FF",
      padding: "5px 0",
    },
  },
  week: {
    "& li": {
      fontFamily: "Poppins",
      textAlign: "center",
      width: "76px",
      height: "40px",
      border: "2px solid #3AC7FF",
      boxSizing: "border-box",
      borderRadius: "2px",
      float: "left",
      margin: "6px",
      fontWeight: "bold",
      fontSize: "12px",
      lineHeight: "24px",
      color: "#3AC7FF",
      padding: "5px 0",
    },
  },
  btn: {
    fontFamily: "Poppins",
    cursor: "pointer",
    display: "inline-block",
    fontWeight: "400",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    MsUserSelect: "none",
    userSelect: "none",
    border: "1px solid transparent",
    padding: ".375rem .75rem",
    fontSize: "1rem",
    lineHeight: "1.5",
    borderRadius: ".25rem",
    transition:
      "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  },
  actDr: {
    background: "#3AC7FF",
    color: "#fff !important",
  },
  actWee: {
    background: "#3AC7FF",
    color: "#fff !important",
  },

  dontaeH4: {
    fontFamily: "Poppins",
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "30px",
    color: "#000000",
    textAlign: "center",
    marginBottom: "12px",
  },
  foundationHead: {
    display: "inline-block",
    textAlign: "center",
    width: "100%",
    "& h6": {
      fontFamily: "Poppins",
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "21px",
      color: "#6C757D",
      opacity: "0.7",
      textAlign: "center",
      marginBottom: "5px",
      marginTop: "20px",
    },
    "& ul": {
      display: "flex",
      flexFlow: "wrap",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: "0px",
      // [theme.breakpoints.down("xs")]: {
      //   padding: "0px !important",
      // },
    },
    "& select": {
      fontFamily: "Poppins",
      border: "1px solid #6C757D",
      boxSizing: "border-box",
      borderRadius: "2px",
      width: "250px",
      opacity: "0.3",
      marginBottom: "30px",
      fontWeight: "bold",
      fontSize: "12px",
      height: "40px",
      padding: "0 11px",
    },

    "& button": {
      fontFamily: "Poppins",
      borderRadius: "4px",
      cursor: "pointer",
      width: "250px",
      height: "47px",
      fontWeight: "800",
      fontSize: "14px",
      lineHeight: "17px",
      color: "#FFFFFF",
      background: "#3AC7FF",
      border: "0",
    },

    "@media (max-width: 600px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  causeImage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 30,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
    },
    "@media (max-width: 959px)": {
      padding: 10,
    },

    "& img": {
      "@media (max-width: 959px)": {
        padding: "40px 40px 0 40px",
      },
      "@media (max-width: 1440px)": {
        padding: 0,
      },
    },
    "@media (max-width: 1400px) and (min-width: 1280px)": {
      maxWidth: "50% !important",
      flexBasis: "50% !important",
    },
    "@media (max-width: 1440px)": {
      display: "flex",
      alignItems: "center",
      paddingLeft: 10,
    },
  },
}));
